import styled from 'styled-components';
import { colors } from '../StylesGlobales/Colors';

export const ContainerNavbar = styled.div`
  position: fixed; /* Set the navbar to fixed position */
  width: 100%;
  top: 0;
  height: 100px;
  box-shadow: ${colors.BOX_SHADOW};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: linear-gradient(135deg, #cb5eee 0%, #6699ff 100%);

  @media (max-width: 768px) {
    height: 70px;
    padding: 0;
  }
`;

export const ContainerLogo = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;

  img {
    display: block;
    /* position: absolute; */
    opacity: 40%;
    transform: translate(0%, -8%);
    width: 120px;
  }
  @media (max-width: 768px) {
    img {
      width: 80px;
      padding-left: 0.8rem;
      transform: translate(0%, -8%);
    }
  }
`;

export const ContainerMenu = styled.div`
  .menu {
    display: flex;
    margin: 0;
    text-align: end;
    font-weight: bolder;
    list-style: none;
    align-items: center;
    justify-content: flex-end;
    gap: 1rem;
  }

  a {
    text-decoration: none;
    padding: 0.5rem;
    font-size: 1.1rem;
    font-weight: 700;
    //color: #054dae;
    color: ${colors.TEXT_WHITE};
  }

  a:hover,
  a:focus {
    color: #054dae;
    //color: gray;
  }
  .active {
    text-decoration: none;
    color: gray;
  }

  @media (max-width: 768px) {
    .navMenu {
      display: ${(props) => (props.showMenuBurger ? 'inline-grid' : 'none')};
      position: absolute;
      top: 70px;
      background: ${colors.BACKGROUND_GRADIENT_GRAY};
      box-shadow: ${colors.BOX_SHADOW};
      width: 100%;
      left: 0;
      padding: 1rem 0;
    }
    .menu {
      flex-direction: column;
      padding: 0px;
    }

    .menuItem {
      padding: 10px 20px;
      font-size: 1rem;
      border-bottom-style: solid;
      color: ${colors.TEXT_BLACK};
    }

    a:hover,
    a:focus {
      color: #6699ff;
    }
  }
`;

export const Button = styled.button`
  color: #054dae;
  box-shadow: ${colors.BOX_SHADOW_BUTTON};

  background: ${colors.TEXT_WHITE};
  padding: 12px 20px;
  border-radius: 999px;
  border: none;
  margin: 10px 0;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;

  @media (max-width: 768px) {
    background: linear-gradient(135deg, #cb5eee 0%, #ff3366 100%);
    font-size: 1rem;
    padding: 0.6rem 2.5rem;
    margin: 5px 15px 0 15px;
  }
`;

export const ContainerBurger = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    margin: 0 auto;
    font-size: 30px;
  }
`;

export const ToggleModeSwitch = styled.div`
  display: flex;
  flex-direction: grow;
  text-align: right;
  padding: 1rem 2rem;
  margin: 2;
`;
